import { keyframes } from '@mui/system';

export const colors = {
    ink: '#10233f',
    body: '#496178',
    muted: '#7b8fa5',
    softBg: '#eef7ff',
    tint: '#f3f8ff',
    border: 'rgba(25, 118, 210, 0.14)'
};

export const pageBackground =
    'radial-gradient(circle at top right, rgba(34, 211, 238, 0.18), transparent 34%), linear-gradient(135deg, #f8fbff 0%, #eef6ff 45%, #ffffff 100%)';

export const heroGradient = 'linear-gradient(135deg, #07182f 0%, #0c3f66 48%, #0aa6a6 100%)';

export const ctaGradient = 'linear-gradient(135deg, #00a884, #1264e2)';

export const primaryGradient = 'linear-gradient(135deg, #1264e2, #00a6c8)';

/** מריץ גרדיאנט צבעוני סביב מסגרת הקוביות שדוחפים */
export const glowShift = keyframes`
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
`;

/** הילה נושמת סביב הכרטיס */
export const glowPulse = keyframes`
    0%, 100% { box-shadow: 0 18px 45px rgba(15, 50, 80, 0.18), 0 0 0 rgba(34, 211, 238, 0); }
    50% { box-shadow: 0 24px 62px rgba(15, 50, 80, 0.24), 0 0 30px rgba(34, 211, 238, 0.45); }
`;

/** משתמשים שביקשו פחות אנימציות במערכת ההפעלה — מכבים את התנועה */
export const reducedMotion = '@media (prefers-reduced-motion: reduce)';
